export const initialState = {
    is_loading: true,
    credit_notes: [],
    total_credit_notes: 0,
    total_pages: 0,
    current_page: 1,
    search_value: ""
}